import React, { useCallback, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import { Typography, Box } from '@mui/material';
import { mainPageRootStyle } from '../styles';
import { createPost } from './actions';
import PostEditForm from './PostEditForm';
import Breadcrumb from '../components/Breadcrumb';
import dayjs from 'dayjs';

const PostAddPage = () => {
    const userId = useSelector(state => state.auth.user?.uid);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const selectedHandle = queryParams.get('handle');

    useEffect(() => {
        document.title = 'Schedule Post - Sky Toolbox';
    }, []);

    const [post, setPost] = useState({ handle: selectedHandle, scheduledFor: dayjs().add(1, "day").toISOString() });
    const [images, setImages] = useState([]);
    const [photoSrcs, setPhotoSrcs] = useState([]);

    const dispatch = useDispatch();
    const navigate = useNavigate()

    // Cleanup: revoke object URLs on unmount to prevent memory leaks
    useEffect(() => {
        return () => {
            photoSrcs.forEach(url => {
                if (url && url.startsWith('blob:')) {
                    URL.revokeObjectURL(url);
                }
            });
        };
    }, [photoSrcs]);

    const handlePostChange = useCallback((p) => {
        setPost(p);
    }, []);

    const handleImagesChange = useCallback((files) => {
        setPhotoSrcs(files.map(f => f.fileURL));
        setImages(files.map(f => f.file));
    }, []);

    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        dispatch(createPost(post, images, userId, navigate));
    }, [post, images, userId, navigate, dispatch]);

    const handleCancel = useCallback(() => {
        navigate(`/scheduler?handle=${selectedHandle}`);
    }, [navigate, selectedHandle]);

    return (
        <Paper style={mainPageRootStyle} sx={{ p: 3 }}>
            <Breadcrumb items={[
                { label: 'Post Scheduler', path: `/scheduler?handle=${selectedHandle}` },
                { label: 'Schedule Post' }
            ]} />
            
            {/* Page Header */}
            <Box 
                sx={{ 
                    background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                    borderRadius: 3,
                    p: 3,
                    mb: 4,
                    color: 'white',
                }}
            >
                <Typography variant="h4" component="h1" fontWeight="bold" sx={{ mb: 1 }}>
                    📝 Schedule Post
                </Typography>
                <Typography variant="body1" sx={{ opacity: 0.9 }}>
                    Create and schedule a new post for your BlueSky account
                </Typography>
            </Box>
            
            <PostEditForm
                handleSubmit={handleSubmit}
                post={post}
                handlePostChange={handlePostChange}
                photoSrcs={photoSrcs}
                handleImagesChange={handleImagesChange}
                handleCancel={handleCancel}
            />
        </Paper>
    );
};

export default PostAddPage;
